import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


const TELECALLER_REPORT_SUMMARY_API_URL = "api/agent-summary-report/";


export const fetchTelecallerReportSummary = createAsyncThunk(
    "agency/fetchTelecallerReportSummary",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            const query = state.filters.query;
            if (!token || !validUser.is_tc) {
                return;
            }


            const response = await axios.get(TELECALLER_REPORT_SUMMARY_API_URL, {
              
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);


const initialState = {
    tele_report_summary: {},
    tele_report_summary_loading: false,


};
const telecallerReportSummary = createSlice({
    name: "telecallerReportSummary",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTelecallerReportSummary.pending, (state) => {
                state.tele_report_summary_loading = true;

            })
            .addCase(fetchTelecallerReportSummary.fulfilled, (state, action) => {
                state.tele_report_summary_loading = false;
                state.tele_report_summary = action.payload;
            })
            .addCase(fetchTelecallerReportSummary.rejected, (state, action) => {
                state.tele_report_summary_loading = false;
                state.tele_report_summary = {};
            })


           
    },
});

export default telecallerReportSummary.reducer;
